import htmx from 'htmx.org'

const outerHTML = 'outerHTML'

document.body.addEventListener('htmx:afterRequest', function (evt) {
  const targetError = evt.target.attributes.getNamedItem('hx-target-error')
  if (evt.detail.failed && targetError) {
    const swapOuter = evt.target.attributes.getNamedItem('hx-swap').value === outerHTML
    if(swapOuter) {
      // If the swap type is outerHTML, we need to swap the entire element out
      const swapTarget = evt.target.attributes.getNamedItem('hx-target').value
      $(swapTarget).empty().append($(targetError.value));

    }
    $(targetError.value).show()
  }
});
document.body.addEventListener('htmx:beforeRequest', function (evt) {
  const targetError = evt.target.attributes.getNamedItem('hx-target-error')
  if (targetError) {
    $(targetError.value).hide()
  }
});